<fc-outlined-select
  [required]="required"
  [label]="label"
  [control]="control"
  [searchFn]="searchCompanies"
></fc-outlined-select>
